import {Fragment, ReactElement} from 'react';
import './App.css';
import './styles.scss';
import './main.scss';
import './styles/handsontable/handsontable.vizibly.full.scss';

import AuthProvider, {AuthIsNotSignedIn, AuthIsSignedIn, AuthIsSigningOut} from './contexts/AuthContext';
import {ChartOfAccountsProvider} from './contexts/chartofaccounts/ChartOfAccountsContext';
import {MainRoute} from './routes/main/MainRoute';
import {PropertiesProvider} from './contexts/properties/PropertiesContext';
import {SettingsProvider} from './contexts/settings/SettingsContext';
import {SignInRoute} from './routes/auth/SignInRoute';
import {VersionsProvider} from './contexts/versions/VersionsContext';
import {AuthorizationContextProvider} from "./authorization/AuthorizationContext";

import {IntercomWrapperRegular} from "./intercom/IntercomWrapperRegular";
import {AppDecider} from "./routes/AppDecider";
import {GuestRoute} from "./routes/guest/GuestRoute";
import {GuestAuthenticationContextProvider} from "./contexts/guest-auth-context/GuestAuthContext";
import {IntercomWrapperGuest} from "./intercom/IntercomWrapperGuest";
import {MixPanelWrapperGuest} from "./mixpanel/MixPanelWrapperGuest";
import {MixPanelWrapperRegular} from "./mixpanel/MixPanelWrapperRegular";
import {LoggingOut} from "./pages/auth/LoggingOut";

const App = ():ReactElement => (<Fragment>
    {/* <AppStarter /> */}
    <AppDecider>
        <AppDecider.GuestRoute>
            <GuestAuthenticationContextProvider>
                <IntercomWrapperGuest>
                    <MixPanelWrapperGuest>
                        <GuestRoute/>
                    </MixPanelWrapperGuest>
                </IntercomWrapperGuest>
            </GuestAuthenticationContextProvider>
        </AppDecider.GuestRoute>
        <AppDecider.RegularRoute>
            <AuthProvider>
                <IntercomWrapperRegular>
                    <MixPanelWrapperRegular>
                        <AuthIsSignedIn>
                            <AuthorizationContextProvider>
                                <PropertiesProvider>
                                    <VersionsProvider>
                                        <ChartOfAccountsProvider>
                                            <SettingsProvider>
                                                <MainRoute />
                                            </SettingsProvider>
                                        </ChartOfAccountsProvider>
                                    </VersionsProvider>
                                </PropertiesProvider>
                            </AuthorizationContextProvider>
                        </AuthIsSignedIn>
                        <AuthIsNotSignedIn>
                            <SignInRoute />
                        </AuthIsNotSignedIn>
                        <AuthIsSigningOut>
                            <LoggingOut />
                        </AuthIsSigningOut>
                    </MixPanelWrapperRegular>
                </IntercomWrapperRegular>
            </AuthProvider>
        </AppDecider.RegularRoute>
    </AppDecider>
</Fragment>);

export default App;
